<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (type of systemLogTypes$ | async; track trackBy(type)) {
      <lcs-option [value]="type" id="lcs-option-id-{{ type.typeId }}">
         {{ type.name | addSpaces }}
      </lcs-option>
      }
   </div>
</ng-template>
